export interface GuidedLoginParams {
  serviceId: string;
  params?: { [param: string]: string };
}

export interface GuidedLoginService {
  id: GuidedLoginServiceId;
  name: string;
  paramsProjectionFunction?: (params: any) => any;
}

export enum GuidedLoginServiceId {
  NONE = '000',
  POLICY_CONSULTATION = '001',
  BANK_DATA_CHANGE = '002',
  DOCUMENTATION = '003',
  ACCIDENT_REPORT = '004',
  ACCIDENT_CONSULTATION = '005',
  MEDICAL_REFUNDS = '006',
  MEDICAL_ASSISTANCE = '007',
  OTHER_SERVICES = '008',
  TECUIDAMOS = '009',
  SECURITAS_DIRECT = '010',
  APP_METS = '011',
  APP_SALUD = '012',
  APP_INVERSION = '013',
  SAVIA = '014',
  FAMILIES = '015',
  FAMILIES_BULLETIN = '016',
  CMMS = '017',
  OFFICIALS = '018',
  MAPFRE_TECUIDAMOS = '019',
  RNR = '020',
}

export const GUIDED_LOGIN_SERVICES: GuidedLoginService[] = [
  {
    id: GuidedLoginServiceId.NONE,
    name: 'None'
  },
  {
    id: GuidedLoginServiceId.POLICY_CONSULTATION,
    name: 'Consulta póliza'
  },
  {
    id: GuidedLoginServiceId.BANK_DATA_CHANGE,
    name: 'Cambio cuenta bancaria'
  },
  {
    id: GuidedLoginServiceId.DOCUMENTATION,
    name: 'Documentación'
  },
  {
    id: GuidedLoginServiceId.ACCIDENT_REPORT,
    name: 'Comunicación siniestro'
  },
  {
    id: GuidedLoginServiceId.ACCIDENT_CONSULTATION,
    name: 'Seguimiento siniestro'
  },
  {
    id: GuidedLoginServiceId.MEDICAL_REFUNDS,
    name: 'Reembolso gastos'
  },
  {
    id: GuidedLoginServiceId.MEDICAL_ASSISTANCE,
    name: 'Consulta asistencias'
  },
  {
    id: GuidedLoginServiceId.OTHER_SERVICES,
    name: 'Otros servicios'
  },
  {
    id: GuidedLoginServiceId.TECUIDAMOS,
    name: 'teCuidamos'
  },
  {
    id: GuidedLoginServiceId.SECURITAS_DIRECT,
    name: 'Securitas direct'
  },
  {
    id: GuidedLoginServiceId.APP_METS,
    name: 'App Mets'
  },
  {
    id: GuidedLoginServiceId.APP_SALUD,
    name: 'App Salud'
  },
  {
    id: GuidedLoginServiceId.APP_INVERSION,
    name: 'App Inversión'
  },
  {
    id: GuidedLoginServiceId.SAVIA,
    name: 'Savia'
  },
  {
    id: GuidedLoginServiceId.FAMILIES,
    name: 'Familias'
  },
  {
    id: GuidedLoginServiceId.FAMILIES_BULLETIN,
    name: 'Boletín Familias'
  },
  {
    id: GuidedLoginServiceId.CMMS,
    name: 'CMMS'
  },
  {
    id: GuidedLoginServiceId.OFFICIALS,
    name: 'Funcionarios'
  },
  {
    id: GuidedLoginServiceId.MAPFRE_TECUIDAMOS,
    name: 'Mapfre teCuidamos',
    paramsProjectionFunction: (params) => {
      return {
        redirect: params?.redirect,
        hashTC: params?.hashTC,
        channel: params?.channel,
        subchannel: params?.subchannel,
        userId: params?.userId
      };
    }
  },
  {
    id: GuidedLoginServiceId.RNR,
    name: 'RnR'
  },
];
